import { icon } from "../resource";

export const POSITION_ACCESS = [
  { icons: [icon.sellcodaBo], value: "ADMIN" },
  { icons: [icon.sellcodaBo], value: "ACCOUNT" },
  { icons: [icon.sellcodaBo, icon.sellcodaSale], value: "SALE" },
  { icons: [icon.sellcodaBo], value: "SALE MANAGER" },
];
